import * as React from 'react';
import { Input, Layout, message } from 'antd';
import { RedoOutlined, CloseOutlined } from '@ant-design/icons';
import { CopilotSession } from './session';
import { getCopilotInstance } from '../../copilot';
import { Message, Action, ActionType, MessageType, OpencuiClient } from '@opencui/copilot-react';
import { localizedString } from '@locale/locale';
import { getAgentId, getCtxFromLocation, getDuhints, getUserId } from '@lib/quick-func';
import { ParameterMapStore } from '@lib/parameter-map';
import { ParameterType } from '@interface/parameter';
import { cloneDeep } from 'lodash';
import { instance as notice } from '@lib/index';
import { FEPage } from '@config/index';
const copilotIcon = require('@static/image/copilot/copilot-xiao.png');


const instance = getCopilotInstance();

const K_LAST_SESSION_AGENT_ID = 'K_LAST_SESSION_AGENT_ID';

function copilotChat(props: any) {

  const [messageList, setMessageList] = React.useState<Message[]>([]);
  const [query, setQuery] = React.useState<string>('');
  const [loading, setLoding] = React.useState<boolean>(false);

  React.useEffect(() => {
    const history = instance.getHistory();

    if (!history || !history.length && !loading) {
      setTimeout(() => {
        handleQuery('');
      }, 500);
    }
    setMessageList(history);
  }, []);

  React.useEffect(() => {
    const ele: HTMLElement | null = document.getElementById('copilot-session-wrap');
    if (ele) {
      ele.scrollTo(0, ele.scrollHeight);
    }

  }, [messageList]);

  function handleQuery(reply?: string, extra?: any) {

    const msg = {
      messageType: MessageType.Text,
      text: reply || query || '',
      user: {
        id: getUserId() || '',
        name: 'Builder'
      }
    };

    const nextList = cloneDeep(messageList);
    if (msg.text && msg.text.length) {
      nextList.push(msg);

      setMessageList([
        ...nextList
      ]);
    }

    setQuery('');
    if (loading) {
      return;
    }
    setLoding(true);

    instance.sendMessage(msg, {
      ...getCtxParams()
      // bot_init: getAgentId() !== getLastSessionAgentId()
    }, getDuhints(), extra).then((resp: Message[]) => {

      nextList.push(...resp);
      setMessageList([
        ...nextList
      ]);
      // setLastSessionAgentId(getAgentId() || '');
    }).catch((err: any) => {
      message.error(err.message);
    }).finally(() => {
      setLoding(false);
    });
  }

  function getCtxParams() {
    const ctx = getCtxFromLocation(location);
    return Object.fromEntries(ctx);
  }


  function getLastSessionAgentId() {
    return window.sessionStorage.getItem(K_LAST_SESSION_AGENT_ID);
  }

  function setLastSessionAgentId(id: string) {
    window.sessionStorage.setItem(K_LAST_SESSION_AGENT_ID, id);
  }

  return <Layout style={{ height: '100%' }}>
    <Layout.Header className="copilot-header" style={{ background: 'white', borderBottom: '1px solid #e7e7f4' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '100%' }}>
        <span>
          <img
            style={{ background: 'inherit', height: 24, marginRight: 16 }}
            className="logo-icon-img" src={copilotIcon}
          />
        </span>
        {/* <RedoOutlined onClick={() => {
          instance.clearHistory();
          setMessageList([]);
        }}>
          {localizedString('reset_copilot_history', undefined, 'Reset Context')}
        </RedoOutlined> */}
        {
          <CloseOutlined
            onClick={() => {
              if (props.onClose) {
                props.onClose();
              }
            }}
          />
        }
      </div>
    </Layout.Header>
    <Layout.Content style={{ height: '100%', paddingLeft: 16 }}>
      <CopilotSession messages={messageList} excuteCardAction={(card: Action) => {
        if (card.actionType === ActionType.reply) {
          setQuery(card.text);
          setTimeout(() => {
            handleQuery(card.text, card.actionParams);
          }, 100);
        } else if (card.actionType === ActionType.click) {
          if (card.url) {
            window.location.href = card.url;
          } else {
            clickAction(card.actionParams);
          }
        } else {
          message.warning(localizedString('copilot_action_not_supported', undefined, 'This action is not supported yet'));
        }
      }} />
    </Layout.Content>
    <Layout.Footer className="copilot-footer" style={{ background: 'white' }}>
      <div className={`search-div`}>
        <Input
          autoFocus
          placeholder={localizedString('demo_placeholder')}
          value={query}
          onPressEnter={() => {
            handleQuery();
          }}
          onChange={(e: any) => {
            setQuery(e.target.value);
          }}
        />
      </div>
    </Layout.Footer>
  </Layout>;
}

export const CopilotChat = copilotChat;

function clickAction(params?: { [key: string]: any }) {

  if (!params) {
    message.warning(localizedString('param_required', undefined, 'Parameters are required!'));
    return;
  }

  switch (params.clickAction) {
    case 'button':
      clickButton(params);
      break;
    case 'custom':
      if (params.targetAction && params.targetAction.action) {
        notice.emit(params.targetAction.action, params.targetAction);
      } else {
        message.warning(localizedString('param_required', undefined, 'Parameters are required!'));
        return;
      }
      break;
    default:
      clickPage(params);
      break;
  }
}

function clickButton(params?: { [key: string]: string }) {
  if (!params || !params.targetButton) {
    message.warning(localizedString('copilot_action_not_supported', undefined, 'This action is not supported yet'));
    return;
  }

  let btnKey = '';

  switch (params.targetButton) {
    case 'clone':
      btnKey = 'unique-btn-clone';
      break;
    case 'debug':
      btnKey = 'unique-btn-debug';
      break;
    case 'addEntityInstance':
      btnKey = 'uinique-btn-add-entity-instance';
      break;
    case 'commit':
      btnKey = 'uinique-btn-commit';
      break;
    case 'deploy':
    case 'deployBackend':
      btnKey = 'uinique-btn-deploy';
      break;
    case 'import':
      btnKey = 'uinique-btn-import';
      break;
    case 'addServiceFunction':
    case 'addFunction':
      btnKey = 'uinique-btn-add-function';
      break;
    case 'addBranch':
      btnKey = 'uinique-btn-add-branch';
      break;
    default:
      break;
  }

  if (!btnKey || !btnKey.length) {
    message.warning(localizedString('copilot_action_not_supported', undefined, 'This action is not supported yet'));
    return;
  }

  const btn: any = document.getElementById(btnKey);

  if (!btn) {
    message.warning(localizedString('copilot_action_button_not_found', undefined, 'The button was not found!'));
    return;
  }
  btn.click();
}

function clickPage(params?: { [key: string]: string }) {

  if (!params || !params.targetPage) {
    message.warning(localizedString('copilot_action_not_supported', undefined, 'This action is not supported yet'));
    return;
  }

  let href: string;
  const tpInfo = params.typeLabel && getType(params.typeLabel);
  const typeId = tpInfo && tpInfo.id;
  let tp: string | undefined;

  if (typeId) {
    switch (tpInfo.type) {
      case ParameterType.INTENT:
        tp = 'intent';
        break;
      case ParameterType.COMPOSITE:
        tp = 'frame';
        break;
      case ParameterType.ENTITY:
        tp = 'entity';
        break;
      default:
        break;
    }
  }

  const slotId = typeId && params.slotLabel && getSlotId(typeId, params.slotLabel);

  // "user","orgList", "orgMember","orgSetting","agentList","typeList","agentSetting","dependency,"version","skillDetail","frameDetail","entityDetail","serviceSchema", "slotDetail", "responseDetail", "transitionDetail"

  switch (params.targetPage as FEPage) {
    case FEPage.user:
      href = '/account';
      break;
    case FEPage.orgList:
      href = '/org';
      break;
    case FEPage.orgMember:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      href = `/org/${params.orgLabel}/member`;
      break;
    case FEPage.orgSetting:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      href = `/org/${params.orgLabel}`;
      break;
    case FEPage.agentList:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      href = `/org/${params.orgLabel}/agent`;
      break;
    case FEPage.typeList:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/type`;
      break;
    case FEPage.agentSetting:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/setting`;
      break;
    case FEPage.providerConnection:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/provider_connection`;
      break;
    case FEPage.dependency:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/library`;
      break;
    case FEPage.version:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/version`;
      break;
    case FEPage.skillDetail:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      if (!typeId) {
        message.warning('type id not found!');
        return;
      }

      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/${tp}/${typeId}`;
      break;
    case FEPage.frameDetail:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      if (!typeId) {
        message.warning('type id not found!');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/${tp}/${typeId}`;
      break;
    case FEPage.entityDetail:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      if (!typeId) {
        message.warning('type id not found!');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/${tp}/${typeId}`;
      break;
    case FEPage.serviceSchema:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/service_schema`;
      break;
    case FEPage.slotDetail:
      if (!params.orgLabel || params.orgLabel === 'null') {
        message.warning('org label is required');
        return;
      }
      if (!params.agentLabel || params.agentLabel === 'null') {
        message.warning('agent label is required');
        return;
      }
      if (!params.lang || params.lang === 'null') {
        message.warning('language of the agent is required');
        return;
      }
      if (!typeId) {
        message.warning('type id not found!');
        return;
      }
      if (!slotId) {
        message.warning('type id not found!');
        return;
      }
      href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/${tp}/${typeId}/slot/${slotId}`;
      break;
    // case 'responseDetail':
    //   href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/intent/${getTypeId(params.typeLabel)}`;
    //   break;
    // case 'transitionDetail':
    //   href = `/org/${params.orgLabel}/agent/${params.agentLabel}/${params.lang}/intent/${getTypeId(params.typeLabel)}`;
    //   break;
    default:
      message.warning(localizedString('copilot_action_not_supported', undefined, 'This action is not supported yet'));
      return;
  }

  const tab = params.tab;

  if (tab && tab !== 'null') {
    if (href.indexOf('?') !== -1) {
      href += `&tab=${tab}`;
    } else {
      href += `?tab=${tab}`;
    }
  }

  window.location.href = href;
  // window.open(href);
}

function getType(label: string) {
  const all = ParameterMapStore.all();

  for (const p of Object.values(all)) {
    if (p.name !== label) {
      continue;
    }

    if (p.type === ParameterType.INTENT || p.type === ParameterType.COMPOSITE || p.type === ParameterType.ENTITY) {
      return p;
    }
  }

  return undefined;
}

function getSlotId(typeId: string, label: string) {
  const all = ParameterMapStore.all();

  for (const p of Object.values(all)) {
    if (p.name !== label) {
      continue;
    }

    if (p.type === ParameterType.ATTRIBUTE && p.ownerId === typeId) {
      return p.id;
    }
  }

  return undefined;
}
